import Axios from 'axios'
import React from 'react'
import { ConfigProvider, Pagination } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import './index.css'
import { data } from 'jquery'
import Header4 from '../../Header/Header4'
import { connect } from 'react-redux'
import nomessage from './img/noMessage.png'

class UserMessage extends React.Component {

    state = {
        tomeStatus: true,
        fromsysStatus: false,
        currentPage: 1,
        total: 0,
        tomeMessageList: [],
        sysMessageList: [],
        frommeMessage: [],
        title: '回复我的'
    }

    // 获取“回复我的”数据
    getToMeMessage = async (userId, currentPage) => {
        const { data: res } = await Axios.get(`${window.url.wd}/comment/getMyComment?userId=${userId}&limit=4&pageNo=${currentPage}`)
        return res
    }

    // 获取“系统通知”数据
    getSystemMessage = async (userId, currentPage) => {
        const { data: res } = await Axios.get(`${window.url.wd}/comment/getSystemMessage?userId=${userId}&limit=5&pageNo=${currentPage}`)
        return res
    }
    // 点击"回复我的"
    handleToMeMessage = async (event) => {
        const res = await this.getToMeMessage(this.props.user.userId, 1)
        if (res.code = '200') {
            const data = res.payload.records
            const total = res.payload.total
            this.setState({
                tomeStatus: true,
                fromsysStatus: false,
                tomeMessageList: data,
                title: '回复我的',
                currentPage: 1,
                total: total
            })
        } else {
            this.setState({
                tomeStatus: true,
                fromsysStatus: false,
                tomeMessageList: [],
                title: '回复我的',
                currentPage: 1,
                total: 0
            })
        }
    }


    // 点击"系统通知"
    handleFromSysMeMessage = async (event) => {
        const res = await this.getSystemMessage(this.props.user.userId, 1)
        if (res.code === '200') {
            const data = res.payload.records
            const total = res.payload.total
            this.setState({
                tomeStatus: false,
                fromsysStatus: true,
                currentPage: 1,
                sysMessageList: data,
                total: total,
                title: '系统通知'
            })
        } else {
            this.setState({
                tomeStatus: false,
                fromsysStatus: true,
                currentPage: 1,
                sysMessageList: [],
                total: 0,
                title: '系统通知'
            })
        }
    }

    // pageSize 点击分页变化的回调
    onShowSizeChange = async (currentPage, state) => {
        // console.log(currentPage)
        // console.log(state)
        if (state.tomeStatus) {
            const res = await this.getToMeMessage(this.props.user.userId, currentPage)
            if (res.code = '200') {
                const data = res.payload.records
                // const total = res.payload.total
                this.setState({
                    tomeMessageList: data,
                    currentPage: currentPage,
                })
            }
        } else if (state.fromsysStatus) {
            const res = await this.getSystemMessage(this.props.user.userId, currentPage)
            if (res.code === '200') {
                const data = res.payload.records
                // const total = res.payload.total
                this.setState({
                    currentPage: currentPage,
                    sysMessageList: data,
                })
            }
        }
    }


    async shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.user.userId != this.props.user.userId) {
            const res = await this.getToMeMessage(nextProps.user.userId, 1)
            if (res.code === '200') {
                const data = res.payload.records
                const total = res.payload.total
                this.setState({
                    tomeMessageList: data,
                    tomeStatus: true,
                    fromsysStatus: false,
                    currentPage: 1,
                    total: total
                })
            } else {
                this.setState({
                    tomeMessageList: [],
                    tomeStatus: true,
                    fromsysStatus: false,
                    currentPage: 1,
                    total: 0
                })
            }
            return true
        } else if (nextState.fromsysStatus || nextState.frommeStatus || nextState.tomeStatus) {
            return true
        } else {
            return null
        }
    }

    async componentDidMount() {
        const res = await this.getToMeMessage(this.props.user.userId, 1)
        if (res.code === '200') {
            const data = res.payload.records
            const total = res.payload.total
            this.setState({
                tomeMessageList: data,
                tomeStatus: true,
                fromsysStatus: false,
                currentPage: 1,
                total: total
            })
        } else {
            this.setState({
                tomeMessageList: [],
                tomeStatus: true,
                fromsysStatus: false,
                currentPage: 1,
                total: 0
            })
        }

        // })
    }
    render() {
        const { tomeStatus, fromsysStatus } = this.state
        return (
            <>
                <Header4></Header4>
                <ConfigProvider locale={zhCN}>
                    <div className="usermessage-bg">
                        <div className="usermessage-container">
                            <aside className="usermessage-container-aside">
                                <header>
                                    <div className="usermessage-container-aside-icon"></div>
                                    <div className="usermessage-container-aside-title">消息中心</div>
                                </header>
                                <section
                                    id="usermeaasge-tome"
                                    className={tomeStatus ? "usermessage-container-aside-item usermessage-container-aside-item-active" : "usermessage-container-aside-item"}
                                    onClick={this.handleToMeMessage}
                                >
                                    回复我的
                                </section>
                                <section
                                    id="usermeaasge-sys"
                                    className={fromsysStatus ? "usermessage-container-aside-item usermessage-container-aside-item-active" : "usermessage-container-aside-item"}
                                    onClick={this.handleFromSysMeMessage}
                                >
                                    系统通知
                                </section>
                                {/* <section
                                    id="usermeaasge-fromme"
                                    className={frommeStatus ? "usermessage-container-aside-item usermessage-container-aside-item-active" : "usermessage-container-aside-item"}
                                    onClick={this.handleFromMeMessage}
                                >
                                    我的消息
                                </section> */}
                            </aside>
                            <content className="usermessage-container-content">
                                <header className="usermessage-container-content-header">
                                    <div className="usermessage-container-content-header-title">
                                        <i className="usermessage-container-content-header-title-icon"></i>
                                        <span id="header-title">{this.state.title}</span>
                                    </div>
                                    {/* <div className="usermessage-container-content-header-mark">
                                    <span className="usermessage-container-content-header-hasmark">全部标记为已读</span>
                                    <span className="usermessage-container-content-header-markall">清除全部</span>
                                </div> */}
                                </header>
                                <div className="usermessage-container-content-content">
                                    {
                                        this.state.tomeMessageList.length === 0 && tomeStatus ? <>
                                            <div className='usermessage-container-nomessage'>
                                                <img src={nomessage} className='usermessage-container-nomessage-background'></img>
                                                <div className="usermessage-container-nomessage-text">暂无消息</div>
                                            </div>
                                        </> : <>{
                                            tomeStatus && this.state.tomeMessageList != [] && this.state.tomeMessageList.map((item, index) => {
                                                // debugger
                                                return (
                                                    <section className="usermessage-container-content-content-item" key={`${item.postId}-${index}`}>
                                                        <aside className="usermessage-container-content-content-item-avatar" style={{ background: `url(${item.avatar}) no-repeat` }}>

                                                        </aside>
                                                        <content className="usermessage-container-content-content-item-content">
                                                            <div className="usermessage-container-content-content-item-content-header">
                                                                <div className="usermessage-container-content-content-item-content-header-username">
                                                                    {item.userName}
                                                                </div>
                                                                <div className="usermessage-container-content-content-item-content-header-createtime">
                                                                    {item.createdTime}
                                                                </div>
                                                            </div>
                                                            <div style={{ overflow: "hidden" }}>
                                                                <div className="usermessage-container-content-content-item-content-content">
                                                                    <p className="usermessage-container-content-content-item-content-content-p" dangerouslySetInnerHTML={{ __html: item.commentBody }}>

                                                                    </p>

                                                                </div>
                                                                <div className="usermessage-container-content-content-item-content-footer">
                                                                    <p className="usermessage-container-content-content-item-content-footer-title">
                                                                        {item.postTitle}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </content>
                                                    </section>
                                                )
                                            })
                                        }</>
                                    }
                                    {
                                        this.state.sysMessageList.length === 0 && fromsysStatus ? <>
                                            <div className='usermessage-container-nomessage'>
                                                <img src={nomessage} className='usermessage-container-nomessage-background'></img>
                                                <div className="usermessage-container-nomessage-text">暂无消息</div>
                                            </div>
                                        </> : <>{
                                            fromsysStatus && this.state.sysMessageList != [] && this.state.sysMessageList.map((item, index) => {
                                                return (
                                                    <section className="sysmessage-container-content-content-item" key={`${item.userId}-${index}`}>
                                                        <div className="sysmessage-container-content-content-item-header">
                                                            <div className="sysmessage-container-content-content-item-header-title">
                                                                {item.userName}
                                                            </div>
                                                            <div className="sysmessage-container-content-content-item-header-createtime">
                                                                {item.createdTime}
                                                            </div>
                                                        </div>
                                                        <div className="sysmessage-container-content-content-item-content">
                                                            <div className="sysmessage-container-content-content-item-content-p" dangerouslySetInnerHTML={{ __html: item.commentBody }}>
                                                            </div>
                                                        </div>
                                                    </section>
                                                )
                                            })
                                        }</>
                                    }
                                    {/* {
                                        frommeStatus && this.state.frommeMessage !== [] && this.state.frommeMessage.map((item) => {
                                            return (<section className="fromme-container-content-content-item">
                                                <aside className="fromme-container-content-content-item-avatar"
                                                    style={{ background: `url(${item.userAvar}) no-repeat` }}
                                                >

                                                </aside>

                                                <content className="fromme-container-content-content-item-content">
                                                    <div className="fromme-container-content-content-item-content-header">
                                                        <div className="fromme-container-content-content-item-content-header-username">
                                                            {item.userName}
                                                        </div>
                                                        <div className="fromme-container-content-content-item-content-header-createtime">
                                                            {item.createTime}
                                                        </div>
                                                    </div>

                                                    <div className="fromme-container-content-content-item-content-content">
                                                        <p className="fromme-container-content-content-item-content-content-p"
                                                            dangerouslySetInnerHTML={{ __html: item.message }}
                                                        >
                                                        </p>
                                                    </div>
                                                </content>


                                            </section>
                                            )
                                        })
                                    } */}

                                </div>
                                <Pagination
                                    className="usermessage-container-content-panigation"
                                    // showSizeChanger
                                    pageSize={tomeStatus ? 4 : 6}
                                    onChange={(currentPage) => this.onShowSizeChange(currentPage, this.state)}
                                    current={this.state.currentPage}
                                    total={this.state.total}
                                    showSizeChanger={false}
                                />
                            </content>
                        </div>
                    </div>
                </ConfigProvider>
            </>
        )
    }
}


const mapState = (state) => ({
    user: state.userReducer.get('user').toJS()
})
export default connect(mapState)(UserMessage)